import styled from "styled-components";

export const CardRoot = styled.div`
  width: 100%;
  height: 500px;
  position: relative;
  background: var(--color-surface);
  border-radius: 1rem;
  transition: transform 0.3s ease;

  &:hover {
    transform: scale(1.05);
  }

  @media (min-width: 1280px) {
    height: 600px;
  }

  @media (min-width: 1536px) {
    height: 700px;
  }
`;

export const CoverImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 1rem;
  display: block;
  cursor: pointer;
`;

export const Panel = styled.div`
  width: 66.666%;
  position: absolute;
  right: 0;
  bottom: 2rem;
  background: #fff;
  padding: 1.5rem;
  border-radius: 1.5rem 0 0 1.5rem;
  box-shadow:
    0 10px 15px -3px rgba(0, 0, 0, 0.1),
    0 4px 6px -4px rgba(0, 0, 0, 0.1);

  @media (min-width: 1536px) {
    padding: 2rem;
  }
`;

export const Title = styled.div`
  font-size: 1rem;
  font-weight: 600;
  color: var(--color-secondary);
  line-height: 1.3;

  b {
    font-weight: 700;
  }

  @media (min-width: 1280px) {
    font-size: 1.125rem;
  }

  @media (min-width: 1536px) {
    font-size: 1.25rem;
  }
`;

export const Description = styled.p`
  margin: 0.5rem 0 0;
  font-size: 0.75rem;
  font-weight: 500;
  color: var(--color-secondary);
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;

  @media (min-width: 1280px) {
    font-size: 0.875rem;
  }

  @media (min-width: 1536px) {
    font-size: 1rem;
  }
`;

export const MetaRow = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 0.5rem;
  margin-top: 1rem;

  @media (min-width: 1536px) {
    flex-direction: row;
    align-items: flex-end;
  }
`;

export const PriceBlock = styled.div`
  p {
    margin: 0;
    font-size: 0.75rem;
    font-weight: 500;
    color: var(--color-secondary);

    @media (min-width: 1280px) {
      font-size: 0.875rem;
    }

    @media (min-width: 1536px) {
      font-size: 1rem;
    }

    &.disclaimer {
      font-size: 0.75rem;
    }
  }

  b {
    font-size: 0.875rem;
    font-weight: 700;
    color: var(--color-secondary);

    @media (min-width: 1280px) {
      font-size: 1rem;
    }

    @media (min-width: 1536px) {
      font-size: 1.125rem;
    }
  }

  .asterisk {
    font-size: 0.875rem;
    font-weight: 500;
    color: var(--color-secondary);
  }
`;

export const UnitBlock = styled.div`
  display: flex;
  gap: 1rem;

  @media (min-width: 1536px) {
    flex-direction: column;
    gap: 0;
  }

  p {
    margin: 0;
    font-size: 0.75rem;
    font-weight: 600;
    color: var(--color-secondary);

    @media (min-width: 1280px) {
      font-size: 0.875rem;
    }

    @media (min-width: 1536px) {
      font-size: 1rem;
    }
  }
`;

export const CtaButton = styled.button`
  width: fit-content;
  margin: 1rem 0 0 auto;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: var(--color-primary);
  color: #fff;
  border: none;
  font-size: 0.75rem;
  font-weight: 500;
  padding: 0.25rem 1rem;
  border-radius: 2rem;
  cursor: pointer;
  transition: background 0.3s ease;

  &:hover {
    background: var(--color-secondary);
  }

  svg {
    width: 0.75rem;
    height: 0.75rem;
    flex-shrink: 0;
  }

  @media (min-width: 1280px) {
    font-size: 0.875rem;
  }

  @media (min-width: 1536px) {
    font-size: 1rem;
  }
`;
